import { obterParametrosDaURL } from "../../../../functions";
import { apiAssinaturaDigital } from "../../api";
import { ApiException } from "../../api-exception";
import { IResumoOrcamentoRequest } from "./VerificarSolicitacaoRespondida";

export const ObterURLDoContrato = async ({
  NumOrc,
  CodLoja,
}: IResumoOrcamentoRequest): Promise<string> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await apiAssinaturaDigital.get<string>(
      `/Contrato/obterurlcontrato`,
      {
        params: { NumOrc, CodLoja },
        headers: { token },
      }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
        erro,
        "Não foi possível obter a URL do contrato"
    );
  }
};